import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import store, { RequestStatus } from '@src/store/index.js';
import { getAndRemoveQueryVariable } from '@src/utils/utils.js';
import Loader from '@src/components/Loader/Loader.jsx';
import natsLogoWhiteSvg from '@assets/nats-logo-white.svg';

import './Connect.css';

function ConnectForm(props) {
  const [code, setCode] = useState(store.suggestedCode);
  function onSubmit(e) {
    e.preventDefault();
    store.connect(code);
  }
  return (
    <div className="connectBody">
      <p className="connectCta">To begin, please enter the code your instructor gives you.</p>
      <form className="connectForm" onSubmit={onSubmit}>
        <input
          className="connectInput code"
          type="text"
          name="code"
          value={code}
          placeholder="Enter code"
          onChange={e => setCode(e.currentTarget.value.toUpperCase())}
        />
        <div className="connectSubmit">
          {!props.loading ? (
            <input type="submit" className="btn connectBtn" value="Submit" disabled={!code} />
          ) : (
            <Loader className="connectLoader" />
          )}
        </div>
      </form>
    </div>
  );
}

function UsernameForm(props) {
  const [userName, setUserName] = useState('');
  function onSubmit(e) {
    e.preventDefault();
    store.connect(props.code, userName);
  }
  return (
    <div className="connectBody">
      <p className="connectCta">You are entering as guest. Please enter a username, e.g. Your initial and surname</p>
      <form className="connectForm" onSubmit={onSubmit}>
        <input
          className="connectInput username"
          type="text"
          name="username"
          value={userName}
          minLength="2"
          maxLength="30"
          placeholder="Enter username"
          onChange={e => setUserName(e.currentTarget.value)}
        />
        <div className="connectSubmit">
          {!props.loading ? (
            <input type="submit" className="btn connectBtn" value="Submit" disabled={!userName} />
          ) : (
            <Loader className="connectLoader" />
          )}
        </div>
      </form>
    </div>
  );
}

export default function Connect() {
  const { status, error, code } = store.connection.use();
  const loading = status === RequestStatus.LOADING;
  return (
    <div className="connectContainer">
      <div className="connectFrame">
        <div className="connectHeader">
          <p className="connectTitle">Welcome to the<br /><strong>Scenario Player</strong></p>
        </div>
        {code ? (
          <UsernameForm loading={loading} code={code} />
        ) : (
          <ConnectForm loading={loading}/>
        )}
        <div className={classNames('connectFooter', !error && 'hidden')}>
          <p className="connectMessage">{error}</p>
        </div>
      </div>
    </div>
  );
}
